import React from 'react';
import VehicleHub from './VehicleHub';

const config = {
  // Blog guides about this model, rendered as the hub's spoke links. Posts
  // whose own target is this hub's query ("buy/used <model> taxi Delhi")
  // are deliberately left out — linking them would build a competitor.
  guides: [
    'second-hand-fortuner-price-delhi-2026',
    'fortuner-taxi-monthly-earnings-delhi',
    'fortuner-private-to-commercial-conversion-delhi',
    'fortuner-commercial-insurance-delhi-2026',
    'fortuner-vs-innova-crysta-taxi-comparison',
  ],
  slug: '/fortuner-commercial-taxi-delhi',
  brand: 'Toyota',
  model: 'Fortuner',
  displayName: 'Toyota Fortuner',
  breadcrumbLabel: 'Fortuner Commercial Taxi — Delhi',
  seoTitle: 'Toyota Fortuner Commercial Taxi for Sale — Delhi NCR',
  seoDescription: 'Buy used Toyota Fortuner commercial taxis in Delhi NCR. Verified BST listings, yellow-plate ready, transparent pricing. Cost of converting private Fortuner to commercial taxi explained.',
  keywords: 'Fortuner commercial taxi Delhi, used Fortuner for sale Delhi, Fortuner yellow plate Delhi, convert Fortuner to commercial taxi Delhi, Toyota Fortuner taxi price Delhi 2026, Fortuner taxi operator Delhi NCR, buy Fortuner taxi Delhi',
  h1: 'Toyota Fortuner Commercial Taxi for Sale in Delhi NCR',
  answerCapsule: 'Used Toyota Fortuner commercial taxis in Delhi NCR are priced from ₹14 lakh to ₹28 lakh based on year, mileage, and variant. The Fortuner is the premium SUV of choice for luxury taxi operators and corporate fleet owners in Delhi. Converting a private Fortuner to a commercial taxi in Delhi costs approximately ₹15,000–₹30,000 in RTO fees and compliance costs.',
  specs: [
    ['Category', 'SUV / Premium Commercial Taxi'],
    ['Engine', '2.8L Diesel (201 bhp) / 2.7L Petrol (164 bhp)'],
    ['Fuel Type', 'Diesel / Petrol'],
    ['Seating', '7 Seats'],
    ['Transmission', 'Manual & Automatic'],
    ['Drive', '4x2 and 4x4'],
    ['Mileage', '10–14 km/l (Diesel)'],
    ['Commercial Permit', 'All India Tourist Permit available'],
    ['Typical Use', 'Luxury outstation, corporate fleet, airport limousine'],
  ],
  priceData: [
    ['2017', '2,00,000 km', '₹14L – ₹17L', 'Good'],
    ['2018', '1,60,000 km', '₹17L – ₹20L', 'Very Good'],
    ['2019', '1,20,000 km', '₹20L – ₹24L', 'Excellent'],
    ['2020', '80,000 km',   '₹23L – ₹27L', 'Excellent'],
    ['2021', '50,000 km',   '₹26L – ₹30L', 'Like New'],
  ],
  whyPoints: [
    'Commands premium fares — Fortuner taxis charge 30–50% more than standard cabs for outstation and corporate runs.',
    'Strong brand perception makes it the preferred choice for luxury fleet contracts in Delhi.',
    'High ground clearance and 4WD options enable hill-station and outstation routes year-round.',
    'Best resale value in the premium SUV segment — a well-maintained Fortuner holds value for 8–10 years commercially.',
    'Available with All India Tourist Permit for inter-state luxury tourism operations.',
  ],
  faqs: [
    {
      q: 'What is the cost of converting a private Fortuner to a commercial taxi in Delhi?',
      a: 'Converting a private Toyota Fortuner (white plate) to a commercial taxi (yellow plate) in Delhi involves: RTO smart card fee (₹200), fitness certificate (₹500–₹1,000), commercial permit fee (₹5,000–₹15,000), and any required vehicle inspection costs. Total estimated cost is ₹15,000–₹30,000. However, it\'s simpler and faster to purchase a Fortuner that already has a commercial yellow plate RC.',
    },
    {
      q: 'What is the resale value of a Toyota Fortuner commercial taxi in Delhi in 2026?',
      a: 'A 2019 Toyota Fortuner with commercial RC and 1.2 lakh km sells for ₹20–24 lakh in Delhi in 2026. The Fortuner consistently holds its value better than most SUVs in the commercial segment due to strong buyer demand and low depreciation. Diesel automatics fetch a higher premium.',
    },
    {
      q: 'Can I operate a Toyota Fortuner as a taxi on Ola or Uber in Delhi?',
      a: 'Yes. Toyota Fortuner with commercial yellow plate RC and a valid taxi permit can be operated on Ola Prime and Uber Black in Delhi. You\'ll need to meet the aggregator\'s vehicle age and condition standards. Most platforms accept vehicles up to 8 years old for premium categories.',
    },
    {
      q: 'What is the difference between a 4x2 and 4x4 Fortuner for taxi use?',
      a: 'For city and outstation taxi use on highways, a 4x2 Fortuner is sufficient and more fuel-efficient. A 4x4 Fortuner commands a higher price but is recommended for operators running Himachal Pradesh, Uttarakhand, or Jammu & Kashmir routes where road conditions require all-wheel drive.',
    },
    {
      q: 'Is the Toyota Fortuner diesel or petrol better for commercial taxi use?',
      a: 'The 2.8L diesel is overwhelmingly preferred for commercial taxi operations due to its fuel efficiency (10–14 km/l) and superior torque for long-distance and hilly routes. The petrol variant is less common in the commercial space. Most buyers on Buy Sell Taxi specifically look for diesel Fortuners with commercial RC.',
    },
  ],
};

const FortunerHub = () => <VehicleHub config={config} />;

export default FortunerHub;
